import { defineComponent as _defineComponent } from 'vue'
import { BaseText, Heading, Modal } from '@warrenbrasil/nebraska-web';
import { Portal } from '@/modules/common/components/Portal';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { ref, onMounted, computed, watch } from 'vue';
import QrcodeVue from 'qrcode.vue';
import { CustomerModule } from '@/modules/common/store/CustomerModule';
import { useRoute, useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'RedirectToMobileModal',
  setup(__props) {

const storeHref = ref('');
const route = useRoute();
const router = useRouter();
const title = ref(
  'Para investir, é muito importante sabermos seu perfil de investidor'
);
const description = ref(
  'Preparamos perguntas para entender seu perfil e ele funcionará como um guia para você fazer escolhas mais conscientes e receber melhores sugestões da Warren.'
);
const subtitle = ref('Descobrir seu perfil');

watch(
  route,
  newRoute => {
    if (newRoute.query.suitabilityModal) {
      CustomerModule.openRedirectToMobileModal();
      setSuitabilityTexts();
    } else if (newRoute.query.regulatoryModal) {
      CustomerModule.openRedirectToMobileModal();
      setRegulatoryUpdateTexts();
    } else {
      CustomerModule.closeRedirectToMobileModal();
    }
  },
  { immediate: true }
);

function setRegulatoryUpdateTexts() {
  title.value = 'Atualize seu cadastro';
  description.value =
    'A atualização é obrigatória conforme as normas da Comissão de Valores Mobiliários, Instrução 617.';
  subtitle.value = 'Atualizar cadastro';
}

function setSuitabilityTexts() {
  title.value =
    'Para investir, é muito importante sabermos seu perfil de investidor';
  description.value =
    'Preparamos perguntas para entender seu perfil e ele funcionará como um guia para você fazer escolhas mais conscientes e receber melhores sugestões da Warren.';
  subtitle.value = 'Descobrir seu perfil';
}

const isOpen = computed(() => {
  return CustomerModule.isRedirectToMobileModalOpen;
});

function handleClose() {
  CustomerModule.closeRedirectToMobileModal();
  setSuitabilityTexts();

  const newQuery = { ...route.query };
  delete newQuery.regulatoryModal;
  delete newQuery.suitabilityModal;

  router.push({
    query: newQuery
  });
}

function mountStoreHref() {
  const currentUrl = window.location.href;
  const [baseUrl] = currentUrl.split('#');
  const pathWithoutSlash = baseUrl.endsWith('/')
    ? baseUrl.slice(0, -1)
    : baseUrl;
  storeHref.value = `${pathWithoutSlash}/#/mobile`;
}

onMounted(() => {
  mountStoreHref();
});

return { __sfc: true,storeHref, route, router, title, description, subtitle, setRegulatoryUpdateTexts, setSuitabilityTexts, isOpen, handleClose, mountStoreHref, BaseText, Heading, Modal, Portal, NebraskaColors, QrcodeVue }
}

})